export default "__VITE_ASSET__CkW83wTG__"